import { Injectable } from '@angular/core';
import { ODataEntitySetService, ODataServiceFactory } from 'angular-odata';
import {Qualification} from '../../models/qualification';
import {exportable$} from './decorators/exportable';
import {ParentTableService} from './parent-table.service';
import {map} from 'rxjs/operators';
import {ODataResponseMapper} from './mappers/odata-response-mapper';
import {SQDataConfiguration} from './configuration/OData-configuration';
import {QUALIFICATION_FLOW} from './configuration/constants';
import {HelperFunctions} from './configuration/helper-functions';

@Injectable({
  providedIn: 'root'
})
export class LopaAftersalesService extends ParentTableService {
  private odata: ODataEntitySetService<Qualification>;
  private readonly config: SQDataConfiguration;
  @exportable$ lopa_aftersales: any;

  constructor(public odataFactory: ODataServiceFactory) {
    super('LopaAftersalesService');
    this.odata = this.odataFactory.entitySet<Qualification>('Overview(0)/Qualification');
    this.config = new SQDataConfiguration();
  }

  getData(pageIndex, count, sortModel, filterModel) {
    const orders = [];
    sortModel.forEach(x => orders.push(x.colId.replace(/\./g, '/') + ' ' + x.sort));

    let filter = `CurrentFlow eq ${QUALIFICATION_FLOW.Standard}`;
    filterModel['QualificationTool'] = {
      filter: 'Lopa Aftersales',
      filterType: 'text',
      type: 'equals'
    };
    filter = HelperFunctions.addOdataFilters(filter, filterModel);

    const query = this.odata.entities().query(q => {
      q.top(count);
      q.skip(count * pageIndex);
      if (orders.length > 0) q.orderBy(orders);
      if (filter?.length) q.filter(filter);
      return q;
    });

    this.lopa_aftersales = query;
    return this.lopa_aftersales.fetch({ withCount: true }).pipe(map((r: any) => ODataResponseMapper.mapResponse(r)));
  }
}
